import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import CustomTextField from "../Components/CustomTextField";
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Button from '@mui/material/Button';



const DoctorInfoBlock = (props) => {



    return (
        <div style={{display:'flex',flex:1,flexDirection:'column',width:'100%'}}>
                        
                     

                        <div style={{ width: '100%', justifyContent: 'space-between',marginBottom:10, flexDirection: 'row', display: 'flex' }}>
                            <div
                                className="doctor-info-card-one"
                            >
                                <span style={{color:props.color?props.color:"#59776F",width:'100%',textAlign:'right',marginBottom:10}}>أسم المستخدم</span>
                                <CustomTextField borderColor={props.color?props.color:"#59776F"} label={"الاسم"} icon={<PersonOutlineIcon style={{color:props.color?props.color:"#59776F"}} />}/>
                                
                            </div>
                            
                            <div
                                className="doctor-info-card-one"
                            >
                                <span style={{color:props.color?props.color:"#59776F",width:'100%',textAlign:'right',marginBottom:10}}>رقم الهاتف</span>
                                <CustomTextField borderColor={props.color?props.color:"#59776F"} label={"رقم الهاتف"} icon={<PhoneIcon style={{color:props.color?props.color:"#59776F"}} />}/>
                            </div>
                            <div
                                className="doctor-info-card-one"
                                style={{marginLeft:'10px'}}
                            >
                                <span style={{color:props.color?props.color:"#59776F",width:'100%',textAlign:'right',marginBottom:10}}>المسمى الوظيفي / الاختصاص</span>
                              <CustomTextField borderColor={props.color?props.color:"#59776F"} label={"المسمى الوظيفي / الاختصاص"} icon={<BusinessCenterIcon style={{color:props.color?props.color:"#59776F"}} />}/>
                            </div>
                        </div>

                        <div style={{ width: '100%',alignItems: 'stretch', justifyContent: 'space-between', flexDirection: 'row', display: 'flex',paddingRight:10 }}>
                            <div
                                className="doctor-info-card-two"
                            >
                                <span style={{color:props.color?props.color:"#59776F",width:'100%',textAlign:'right',marginBottom:10}}>العنوان</span>
                                <CustomTextField borderColor={props.color?props.color:"#59776F"} label={"بغداد - الحارثية شارع الكندي / مجاور مول بغداد"} multiline={false} icon={<LocationOnIcon style={{color:props.color?props.color:"#59776F"}}/>}/>
                                
                            </div>
                            
                            
                            <div
                                className="doctor-info-save-button-container"
                               style={{marginLeft:'10px'}}
                            >
                               <Button variant="contained"
                                    
                                    onClick={() => {  }}
                                    sx={{
                                        fontFamily: " 'Tajawal', sans-serif",
                                        backgroundColor: props.color?props.color:'#59776E',
                                        color: '#fff',
                                        height:'40px',
                                        flex:1,
                                        marginRight:"10px",
                                        boxShadow:'#00000033 0px 3px 6px',
                                        fontSize: '20px',
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        

                                        '&:hover': {
                                            backgroundColor: '#FFFFFF',
                                            color: props.color?props.color:'#59776E',
                                        },
                                        borderRadius: '15px',
                                        borderColor: '#707070',
                                        borderWidth: 1,
                                        borderStyle: 'solid',
                                        
                                    }}>
                                    حفظ المعلومات
                                    </Button>
                            </div>
                        </div>
        </div>
   
    )
}


export default DoctorInfoBlock;